/**
 * Misc styling constants
 */
export default Object.freeze({
  app_min_width: '380px',
  app_min_height: '591px',
  fontSizeSidebar: '14px',
  fontSizeM: '13px',
  fontSizeL: '18px',
  fontSizeXL: '35px',
  box_shadow: '0 3px 20px -5px #8d8d8d',
  box_shadow_small: '0 3px 10px -5px #8d8d8d',
  box_shadow_test:
    '0 1px 1px 0 rgba(60, 64, 67, .08), 0 1px 3px 1px rgba(60,64,67,.16)',
  box_shadow_dark: '0 3px 20px -5px #4d4d4d',
  box_shadow_green:
    '0 3px 20px -5px #8d8d8d, 0 0 0 0.2rem rgba(0, 198, 174, 0.2)', // '0 3px 20px -5px #8d8d8d, 0px 0px 2px 1px rgba(0, 198, 174, 1)',
  box_shadow_green_dark:
    '0 3px 20px -5px #4d4d4d, 0px 0px 2px 1px rgba(0, 198, 174, 1)',
  box_shadow_red:
    '0 3px 20px -5px #8d8d8d, 0 0 0 0.2rem rgba(255, 65, 54, 0.3)',
  box_shadow_red_dark:
    '0 3px 20px -5px #4d4d4d, 0 0 0 0.2rem rgba(255, 65, 54, 0.3)',
  box_shadow_red_unfocused:
    '0 3px 20px -5px #8d8d8d, 0 0 0 0.2rem rgba(255, 65, 54, 0.3)',
  transition: (property, time = '50ms') =>
    `${property} ${time} cubic-bezier(0.4, 0.0, 0.2, 1)`,
  top_menu_height: '50px'
});
